import { Actionable, Icon, Popover, Text, View } from 'reshaped/bundle'
import { SimpleOfferIcon } from 'components/domain/search/offers/common/icons/icons'
import { CategoryDetails, DisplayDetails } from 'generated/api'

interface RibbonProps {
	categoryDetails: CategoryDetails
	display?: DisplayDetails
}

export const Ribbon = ({ categoryDetails, display }: RibbonProps) => (
	<View
		height="2rem"
		borderRadius="small"
		backgroundColor="primary-faded"
		paddingInline={4}
		direction="row"
		align="center"
		attributes={{
			style: {
				justifyContent: 'space-between'
			}
		}}
	>
		<Popover triggerType="hover">
			<Popover.Trigger>
				{attributes => (
					<Actionable attributes={attributes}>
						<Text color="primary">{categoryDetails.title}</Text>
					</Actionable>
				)}
			</Popover.Trigger>
			<Popover.Content> {categoryDetails.details}</Popover.Content>
		</Popover>
		<View direction="row" gap={2} align="center">
			<Icon svg={<SimpleOfferIcon />} size={4} color="primary" />
			<Text color="primary">{display?.ribbonText}</Text>
		</View>
	</View>
)
